import { httpClient2 } from "../utils/httpClient2";

import { RollupsType } from "modules/projects/types/entities";
import {
  IFetchAssignedExperimentsByLeadDto,
  IFetchDashboardProjectsDto,
  IFetchDashboardTodosDto,
  IFetchStatusExperimentsDto
} from "../types/dto";
import {
  IDashboardStatusesResponse,
  IDashboardUsersResponse,
  IDashboardProjectsResponse,
  IStatusExperimentsResponse,
  IDashboardTodosResponse,
  IFetchAssignedExperimentsByLeadResponse,
  IFetchAssignedExperimentsByStageResponse
} from "../types/res";

export const fetchDashboardStatuses = async ({
  project_id,
  rollups
}: {
  project_id: string;
  rollups: RollupsType;
}) => {
  const res = await httpClient2.get<IDashboardStatusesResponse>(
    "/dashboard/statuses_counts",
    {
      params: { project_id, rollups }
    }
  );

  return res.data;
};

export const fetchExperimentsByStatus = async (
  dto: IFetchStatusExperimentsDto
) => {
  const res = await httpClient2.get<IStatusExperimentsResponse>(
    "/dashboard/status_experiments",
    {
      params: { ...dto }
    }
  );

  return res.data;
};

export const fetchDashboardUsers = async ({
  project_id,
  rollups
}: {
  project_id: string;
  rollups: RollupsType;
}) => {
  const res = await httpClient2.get<IDashboardUsersResponse>(
    "/dashboard/users",
    {
      params: { project_id, rollups }
    }
  );

  return res.data;
};

export const fetchDashboardProjects = async (
  dto: IFetchDashboardProjectsDto
) => {
  const res = await httpClient2.get<IDashboardProjectsResponse>(
    "/dashboard/projects",
    {
      params: { ...dto }
    }
  );

  return res.data;
};

export const fetchDashboardTodos = async (dto: IFetchDashboardTodosDto) => {
  const res = await httpClient2.get<IDashboardTodosResponse>(
    "/dashboard/todos",
    {
      params: { ...dto }
    }
  );

  return res.data;
};

export const fetchAssignedExperimentsByLead = async (
  dto: IFetchAssignedExperimentsByLeadDto
) => {
  const res = await httpClient2.get<IFetchAssignedExperimentsByLeadResponse>(
    "/dashboard/assigned_experiments_by_lead",
    {
      params: { ...dto }
    }
  );

  return res.data;
};

export const fetchAssignedExperimentsByStage = async (
  dto: IFetchAssignedExperimentsByLeadDto
) => {
  const res = await httpClient2.get<IFetchAssignedExperimentsByStageResponse>(
    "/dashboard/assigned_experiments_by_stage",
    {
      params: { ...dto }
    }
  );

  return res.data;
};
